import { config } from '@iheartjane/config';

import { request } from '@jane/monolith/lib/request';
import type { Identification } from '@jane/shared/types';

export class IdentificationSource {
  static urlRoot = `${config.apiPath}/documents`;

  static get() {
    return request(this.urlRoot, {
      method: 'GET',
    });
  }

  static update(documentPart: { document: Partial<Identification> }) {
    return request(this.urlRoot, {
      method: 'PATCH',
      body: JSON.stringify(documentPart),
    });
  }
}
